import React, { FC } from 'react';

import { isBrowser, I18nDataEdges } from '@lucid/utils';
import Cookies from 'js-cookie';
import {
  SiteNavbar,
  SiteNavbarOptionalProps,
} from '@lucid/components-react';

import { useMenuTopNavigation } from 'hooks/use-menu';
import useNavButtons, { placeholderButtons as initialPlaceholderButtons } from 'hooks/use-nav-buttons';

export interface NavbarProps extends SiteNavbarOptionalProps {
  /** The i18n translation data. */
  i18nData: I18nDataEdges;
  /** The logo to be displayed in the Navbar. */
  logo: string | JSX.Element;
  /** The language currently set for the page context. */
  langPrefix: string;
  /** Checks if we should hide the signup button. */
  shouldHideSignUpButton?: boolean;
}

const Navbar: FC<NavbarProps> = ({ i18nData, langPrefix, logo, shouldHideSignUpButton, ...rest }) => {
  // Navbar props
  const navbarMenu = useMenuTopNavigation(langPrefix);
  const username = isBrowser()
    ? window.atob(Cookies.get('username') || '')
    : undefined;
  const initialNavButtons = useNavButtons(username, shouldHideSignUpButton);

  return (
    <SiteNavbar
      {...rest}
      i18nData={i18nData}
      initialNavButtons={initialNavButtons}
      initialPlaceholderButtons={initialPlaceholderButtons}
      logo={logo}
      menu={navbarMenu}
    />
  );
};

export default Navbar;
